import { useEffect } from 'react';

function useOutsideClick(ref, callback) {
  const handleClick = e => {
    // e.stopPropagation();
    if (ref.current && !ref.current.contains(e.target)) {
      callback();
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  });
}
export default useOutsideClick;
